module.exports = ".page-images {\r\n    background: url('title-image.jpg');\r\n    background-position: center;\r\n}"